import TomSelect from "./tom-select/tom-select.0c9bda91e62b.js";
import {
  renderTurquoiseSpinner,
  addTomSelectAriaLabel,
} from "./fancy-dropdowns.6a3871cf8272.js";

const GOOGLE_TRANSLATE_COOKIE_NAME = "googtrans";

// Language data for the language selector
const SUPPORTED_LANGUAGES = [
  { code: "en", name: "English", native: "English" },
  { code: "es", name: "Spanish", native: "Español" },
  { code: "zh-CN", name: "Chinese (Simplified)", native: "简体中文" },
  { code: "zh-TW", name: "Chinese (Traditional)", native: "繁體中文" },
  { code: "fr", name: "French", native: "Français" },
  { code: "de", name: "German", native: "Deutsch" },
  { code: "it", name: "Italian", native: "Italiano" },
  { code: "ja", name: "Japanese", native: "日本語" },
  { code: "ko", name: "Korean", native: "한국어" },
  { code: "pt", name: "Portuguese", native: "Português" },
  { code: "ru", name: "Russian", native: "Русский" },
  { code: "ht", name: "Haitian Creole", native: "Kreyòl ayisyen" },
  { code: "ar", name: "Arabic", native: "العربية" },
  { code: "hi", name: "Hindi", native: "हिन्दी" },
  { code: "vi", name: "Vietnamese", native: "Tiếng Việt" },
  { code: "tl", name: "Filipino", native: "Filipino" },
  { code: "pl", name: "Polish", native: "Polski" },
  { code: "uk", name: "Ukrainian", native: "Українська" },
  { code: "tr", name: "Turkish", native: "Türkçe" },
  { code: "nl", name: "Dutch", native: "Nederlands" },
  { code: "sv", name: "Swedish", native: "Svenska" },
  { code: "no", name: "Norwegian", native: "Norsk" },
  { code: "da", name: "Danish", native: "Dansk" },
  { code: "fi", name: "Finnish", native: "Suomi" },
  { code: "el", name: "Greek", native: "Ελληνικά" },
  { code: "he", name: "Hebrew", native: "עברית" },
  { code: "th", name: "Thai", native: "ไทย" },
  { code: "id", name: "Indonesian", native: "Bahasa Indonesia" },
  { code: "ms", name: "Malay", native: "Bahasa Melayu" },
  { code: "cs", name: "Czech", native: "Čeština" },
  { code: "sk", name: "Slovak", native: "Slovenčina" },
  { code: "hu", name: "Hungarian", native: "Magyar" },
  { code: "ro", name: "Romanian", native: "Română" },
  { code: "bg", name: "Bulgarian", native: "Български" },
  { code: "hr", name: "Croatian", native: "Hrvatski" },
  { code: "sr", name: "Serbian", native: "Српски" },
  { code: "sl", name: "Slovenian", native: "Slovenščina" },
  { code: "lt", name: "Lithuanian", native: "Lietuvių" },
  { code: "lv", name: "Latvian", native: "Latviešu" },
  { code: "et", name: "Estonian", native: "Eesti" },
  { code: "fa", name: "Persian", native: "فارسی" },
  { code: "ur", name: "Urdu", native: "اردو" },
  { code: "bn", name: "Bengali", native: "বাংলা" },
  { code: "ta", name: "Tamil", native: "தமிழ்" },
  { code: "te", name: "Telugu", native: "తెలుగు" },
  { code: "mr", name: "Marathi", native: "मराठी" },
  { code: "gu", name: "Gujarati", native: "ગુજરાતી" },
  { code: "kn", name: "Kannada", native: "ಕನ್ನಡ" },
  { code: "ml", name: "Malayalam", native: "മലയാളം" },
  { code: "pa", name: "Punjabi", native: "ਪੰਜਾਬੀ" },
  { code: "ne", name: "Nepali", native: "नेपाली" },
  { code: "si", name: "Sinhala", native: "සිංහල" },
  { code: "my", name: "Burmese", native: "မြန်မာ" },
  { code: "km", name: "Khmer", native: "ខ្មែរ" },
  { code: "lo", name: "Lao", native: "ລາວ" },
  { code: "ka", name: "Georgian", native: "ქართული" },
  { code: "am", name: "Amharic", native: "አማርኛ" },
  { code: "sw", name: "Swahili", native: "Kiswahili" },
  { code: "zu", name: "Zulu", native: "isiZulu" },
  { code: "xh", name: "Xhosa", native: "isiXhosa" },
  { code: "af", name: "Afrikaans", native: "Afrikaans" },
  { code: "sq", name: "Albanian", native: "Shqip" },
  { code: "eu", name: "Basque", native: "Euskara" },
  { code: "be", name: "Belarusian", native: "Беларуская" },
  { code: "ca", name: "Catalan", native: "Català" },
  { code: "eo", name: "Esperanto", native: "Esperanto" },
  { code: "ga", name: "Irish", native: "Gaeilge" },
  { code: "gl", name: "Galician", native: "Galego" },
  { code: "is", name: "Icelandic", native: "Íslenska" },
  { code: "mk", name: "Macedonian", native: "Македонски" },
  { code: "mt", name: "Maltese", native: "Malti" },
  { code: "cy", name: "Welsh", native: "Cymraeg" },
  { code: "yi", name: "Yiddish", native: "ייִדיש" },
];

// Initialize Google Translate when the script loads
if (!window.googleTranslateElementInit) {
  window.googleTranslateElementInit = function () {
    // Create the Google Translate element if it doesn't exist
    if (!document.getElementById("google_translate_element")) {
      const gtElement = document.createElement("div");
      gtElement.id = "google_translate_element";
      gtElement.style.display = "none";
      document.body.appendChild(gtElement);
    }

    new google.translate.TranslateElement(
      {
        pageLanguage: "en",
        autoDisplay: false,
      },
      "google_translate_element",
    );
  };

  // Load Google Translate script
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src =
    "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
  document.head.appendChild(script);
}

class LanguageSelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.languageInput = this.querySelector("#language-selector-input");
    const currentLanguage = this.detectCurrentLanguage();
    this.setupLanguageDropdown(currentLanguage);
    this.applyStyles();
    this.setupCookieChangeListener();
  }

  disconnectedCallback() {
    if (this.tomSelectInstance) {
      this.tomSelectInstance.destroy();
    }
    if (this.cookieChangeListener) {
      cookieStore.removeEventListener("change", this.cookieChangeListener);
    }
  }

  detectCurrentLanguage() {
    // Check Google Translate cookie to detect current language (and yes, this is sadly the cleanest way to do this)
    const googleTranslateCookie = document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${GOOGLE_TRANSLATE_COOKIE_NAME}=`));

    if (googleTranslateCookie) {
      const [_cookieName, cookieValue] = googleTranslateCookie.split("=");
      return this.parseLanguageFromCookieValue(cookieValue);
    }

    // Default to English if cookie is not set
    return "en";
  }

  setupLanguageDropdown(currentLanguage) {
    this.tomSelectInstance = new TomSelect(this.languageInput, {
      valueField: "code",
      labelField: "name",
      searchField: ["name", "native"],
      options: SUPPORTED_LANGUAGES,
      items: [currentLanguage],
      create: false,
      maxOptions: null,
      dropdownParent: this.languageInput.parentElement.parentElement,
      selectOnTab: true,
      allowEmptyOption: false,
      openOnFocus: true,
      render: {
        loading: renderTurquoiseSpinner,
        option: function (data, escape) {
          return `<div class="pv-text-body-sm">${escape(
            data.native,
          )} <span class="pv-text-body-sm pv-text-subdued">(${escape(
            data.name,
          )})</span></div>`;
        },
        item: function (data, escape) {
          return `<div class="pv-text-title-sm">${escape(data.native)}</div>`;
        },
      },
    });

    addTomSelectAriaLabel(this.languageInput, this.tomSelectInstance);

    this.tomSelectInstance.on("change", (languageCode) => {
      const selectElement = document.querySelector(".goog-te-combo");
      // Find the option with the matching language code
      const options = Array.from(selectElement.options);
      const targetOption = options.find((opt) => opt.value === languageCode);

      if (targetOption) {
        selectElement.value = languageCode;
        // Programmatically trigger the language translation
        selectElement.dispatchEvent(new Event("change", { bubbles: true }));

        // Hide the language selector dropdown after selection
        if (this.tomSelectInstance) {
          this.tomSelectInstance.close();
        }

        // Close the language modal if it's open (mobile only)
        if (document.body.hasAttribute("data-language-modal")) {
          document.body.removeAttribute("data-language-modal");
        }
      }
    });

    this.tomSelectInstance.on("dropdown_close", () => {
      // tom-select quirk
      this.tomSelectInstance.blur();
    });
  }

  applyStyles() {
    this.tomSelectInstance.control.style.minWidth = "120px";
    this.tomSelectInstance.dropdown.style.minWidth = "250px";
    this.tomSelectInstance.control.style.visibility = "visible";
  }

  setupCookieChangeListener() {
    this.cookieChangeListener = (event) => {
      // Check if the Google Translate cookie changed
      const googleTranslateCookie = event.changed.find(
        (cookie) => cookie.name === GOOGLE_TRANSLATE_COOKIE_NAME,
      );

      if (googleTranslateCookie) {
        // Parse language from cookie value (format: /en/es or /en/zh-CN)
        const currentLanguage = this.parseLanguageFromCookieValue(
          googleTranslateCookie.value,
        );
        this.updateLanguageSelector(currentLanguage);
      }

      // Also check for deleted cookies (when translation is cleared)
      const deletedGoogleTranslateCookie = event.deleted.find(
        (cookie) => cookie.name === GOOGLE_TRANSLATE_COOKIE_NAME,
      );

      if (deletedGoogleTranslateCookie) {
        // Cookie was deleted, reset to English
        this.updateLanguageSelector("en");
      }
    };

    cookieStore.addEventListener("change", this.cookieChangeListener);
  }

  parseLanguageFromCookieValue(cookieValue) {
    // Cookie format is like: /en/es or /en/zh-CN
    if (!cookieValue) return "en";
    const parts = cookieValue.split("/");
    // Return the target language (third part) or 'en' if parsing fails
    return parts.length >= 3 ? parts[2] : "en";
  }

  updateLanguageSelector(currentLanguage) {
    // Update the language selector to match the current state
    if (
      this.tomSelectInstance &&
      this.tomSelectInstance.getValue() !== currentLanguage
    ) {
      this.tomSelectInstance.setValue(currentLanguage, true); // true = silent (don't trigger change event)
    }
  }
}

customElements.define("language-selector", LanguageSelector);
